import {createSelector} from '@reduxjs/toolkit';

import {GOOD_ITEM_TYPES} from '@explorer/constants/item-types';

const getItemTypes = state => state.itemTypes;

export const getAvailableItemTypes = createSelector(getItemTypes, itemTypes => {
  // TODO: Move this line to the item types reducer (this filters item types from the api that we never want)?
  const types = itemTypes.types.filter(itemType => itemType in GOOD_ITEM_TYPES);

  const itemTypesState = {
    ...itemTypes,
    types,
  };

  return itemTypesState;
});

export const getSelectedItemTypes = state => state.itemTypes.selected;

export const getDisplayName = createSelector(
  getItemTypes,
  (_, itemType) => itemType,
  ({typesMap = {}}, itemType) =>
    itemType in typesMap ? typesMap[itemType].display_name : itemType
);
